<template>
    <div class="layout-wrapper">
        <AppHeader />
        <div class="layout-main-container">
            <div class="layout-main">
                <router-view />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import AppHeader from '@/components/AppHeader.vue';
</script>

<style scoped>
.layout-wrapper {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
}

.layout-main-container {
    flex: 1;
    display: flex;
}

.layout-main {
    flex: 1;
    padding: 2rem;
}
</style>
